export default function initM11() {
const $ = jQuery
$(window).on("load",function(){
   var owl = $('.owl-culture');
   owl.owlCarousel({
      center: true, autoHeight : true,
      //autoWidth:true,
      loop:true,
      margin:0,
      items:1
      // responsive:{
      //    600:{
      //          items:4
      //    }
      // }
   });
});
}